var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { isFile, isFormData, isTypeObject } from '@autobest-ui/utils';
/**
 * 默认请求前的拦截器，主要用于添加Content-Type和解析body成相应格式等基本功能
 * @param requestArgs
 */
export function defaultTransformRequest(requestArgs) {
  var body = requestArgs.requestConfig.body;
  if (isFormData(body) || isFile(body)) {
    return requestArgs;
  }
  requestArgs.requestConfig.headers['Content-Type'] = 'application/json';
  requestArgs.requestConfig.body = isTypeObject(body) ? JSON.stringify(body) : body;
  return requestArgs;
}
/**
 * 默认请求后的拦截器，处理基本的json解析
 * @param response
 * @param requestArgs
 */
export function defaultTransformResponse(response, requestArgs) {
  return __awaiter(this, void 0, void 0, function () {
    var jsonInfo, error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!(requestArgs.responseType === 'json' && !response.isSetResponseAtRequest)) return [3 /*break*/, 4];
          _a.label = 1;
        case 1:
          _a.trys.push([1, 3,, 4]);
          return [4 /*yield*/, response.json()];
        case 2:
          jsonInfo = _a.sent();
          return [2 /*return*/, __assign({
            status: response.status
          }, jsonInfo)];
        case 3:
          error_1 = _a.sent();
          return [2 /*return*/, Promise.reject(__assign(__assign({
            status: response.status,
            code: response.status,
            data: null
          }, response), {
            success: false,
            message: "".concat(response.statusText || '').concat(error_1 instanceof Error ? error_1.message : error_1)
          }))];
        case 4:
          return [2 /*return*/, response];
      }
    });
  });
}
/**
 * 默认请求后的拦截器，处理error
 * @param reason
 */
export function defaultTransformResponseError(reason) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      if (reason.name === 'AbortError') {
        return [2 /*return*/, Promise.reject({
          status: 0,
          code: 0,
          data: null,
          stack: reason.message,
          message: 'You abort this request.'
        })];
      }
      return [2 /*return*/, Promise.reject(__assign(__assign({
        status: 0,
        code: 0
      }, reason), {
        message: reason.message,
        stack: reason.stack,
        success: false
      }))];
    });
  });
}